module.exports = __webpack_public_path__ + "static/media/logo.2280fa2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 129
// module chunks = 0